.dashboard {
  h5 {
    margin-left: 29px;
    margin-bottom: 10px;
  }

  .reportList {
    display: flex;
    flex-direction: row;
    align-items: center;
    flex-wrap: wrap;
    justify-content: flex-start;
    margin-left: 29px;
    margin-bottom: 15px;

    .report {
      width: 252px;
      height: 149px;
      position: relative;
      margin-right: 10px;
      margin-bottom: 10px;

      .mask {
        position: absolute;
        width: 100%;
        height: 100%;
        opacity: 0.9;
        background-color: #91cbe0;
      }

      .nameOverlay {
        position: absolute;
        display: flex;
        align-items: center;
        justify-content: center;
        height: 100%;
        width: 100%;
        color: #fff;
        font-size: 15px;
        box-sizing: border-box;
        padding: 0 40px;
        text-shadow: 0px 0px 6px #000;
        font-family: var(--font-family__heading);
      }

      img {
        height: 100%;
        width: 100%;
      }
    }
  }
}

.container {
  margin-top: 7px;

  h1 {
    margin-bottom: 23px;
  }
}
